export const CartIcon = ({ height = 32, width = 32, fill = "black" }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>shopping bag</title>
      <g fill="#050505" stroke="#050505" strokeLinecap="round" strokeWidth="2">
        <path
          d="M53.142,62H10.858A5,5,0,0,1,5.92,56.214L12,18H52l6.08,38.214A5,5,0,0,1,53.142,62Z"
          fill="none"
          stroke="#050505"
        />
        <path
          d="M22,28V12A10,10,0,0,1,32,2h0A10,10,0,0,1,42,12V28"
          fill="none"
        />
      </g>
    </svg>
  );
};

export const SearchIcon = ({ height = 32, width = 32, className = "", fill = "black" }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>search</title>
      <g fill="#050505">
        <path
          d="M27.166 27.461c.388-.177.59-.446.666-.817v-.033l.008-.034v-.202a.775.775 0 0 1-.042-.143c-.025-.076-.042-.135-.06-.177a1.109 1.109 0 0 0-.285-.337l-2.518-2.206c-.842-.741-1.684-1.466-2.501-2.198-.085-.076-.21-.177-.236-.37-.009-.186.11-.304.194-.397a9.785 9.785 0 0 0 2.332-3.84 9.205 9.205 0 0 0 .388-3.79c-.203-1.944-.96-3.696-2.24-5.203-1.44-1.685-3.293-2.83-5.508-3.41a9.86 9.86 0 0 0-2.088-.312L13.735 4c-1.634.135-3.15.59-4.514 1.381-2.139 1.221-3.655 2.947-4.53 5.12a8.849 8.849 0 0 0-.607 2.779v.025c-.008.657-.008 1.162.034 1.348v.008c.236 1.903.834 3.495 1.836 4.842 1.355 1.81 3.174 3.082 5.431 3.79 1.255.387 2.594.547 3.941.454 1.6-.11 3.116-.539 4.514-1.296.236-.127.463-.11.665.075.876.767 1.769 1.55 2.62 2.308.858.758 1.76 1.532 2.643 2.299.278.244.489.362.733.404.025 0 .042.008.067.008h.245c.025-.008.05-.008.084-.017a.964.964 0 0 0 .27-.067zm-10.922-5.945c-.59.11-1.179.168-1.751.168-2.013 0-3.832-.673-5.44-2.03A7.368 7.368 0 0 1 6.5 15.428c-.396-1.903-.11-3.713.901-5.372 1.12-1.878 2.804-3.116 4.985-3.722a8.438 8.438 0 0 1 3.369-.21c1.793.243 3.36.984 4.657 2.205a7.68 7.68 0 0 1 2.282 4c.11.472.16.952.16 1.449-.009 2.114-.767 3.95-2.257 5.431a8.093 8.093 0 0 1-4.354 2.308z"
          fill="#050505"
        />
      </g>
    </svg>
  );
};

export const SearchAndAddIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="20px"
    viewBox="0 0 24 20"
    version="1.1"
    className={className}
  >
    <title>Group 18</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="2.1-Zoznamy_detail-search-autofill"
        transform="translate(-438.000000, -195.000000)"
      >
        <g id="Group-18" transform="translate(439.000000, 195.000000)">
          <text
            id="+"
            font-family="NunitoSans-SemiBold, Nunito Sans"
            font-size="12"
            font-weight="500"
            line-spacing="13"
            fill="#111111"
          >
            <tspan x="14" y="12">
              +
            </tspan>
          </text>
          <g
            id="Group"
            transform="translate(0.000000, 4.000000)"
            stroke="#56AB2F"
            stroke-width="1.5"
          >
            <g id="Search-Icon">
              <circle
                id="Oval"
                cx="5.71428571"
                cy="5.71428571"
                r="5.71428571"
              />
              <line
                x1="9.14285714"
                y1="12.5714286"
                x2="14.8571429"
                y2="12.5714286"
                id="Line"
                stroke-linecap="square"
                transform="translate(12.000000, 12.571429) rotate(45.000000) translate(-12.000000, -12.571429) "
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const SettingsIcon = ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    className={className}
  >
    <title>settings</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="2.1-Zoznamy_detail-search-autofill"
        transform="translate(-722.000000, -197.000000)"
        fill="#56AB2F"
        fill-rule="nonzero"
      >
        <g id="settings" transform="translate(722.000000, 197.000000)">
          <path
            d="M9.84,18 L8.16,18 C7.59225,18 7.113,17.57475 7.0455,17.01 L6.86625,15.603 C6.5085,15.48675 6.1635,15.3435 5.83575,15.17625 L4.71525,16.047 C4.26075,16.39875 3.621,16.35825 3.2265,15.9525 L2.04525,14.77125 C1.6425,14.3805 1.602,13.74075 1.95375,13.287 L2.8245,12.16575 C2.6565,11.838 2.51325,11.493 2.39775,11.13525 L0.98775,10.956 C0.42525,10.887 0,10.40775 0,9.84 L0,8.16 C0,7.59225 0.42525,7.113 0.99,7.0455 L2.397,6.86625 C2.51325,6.5085 2.6565,6.1635 2.82375,5.83575 L1.95375,4.71525 C1.60125,4.26075 1.6425,3.62025 2.049,3.22575 L3.23025,2.0445 C3.621,1.64175 4.2615,1.602 4.7145,1.953 L5.835,2.8245 C6.16275,2.65725 6.50775,2.514 6.86625,2.39775 L7.0455,0.98775 C7.113,0.42525 7.59225,0 8.16,0 L9.84,0 C10.40775,0 10.887,0.42525 10.9545,0.99 L11.13375,2.397 C11.49225,2.51325 11.83725,2.6565 12.165,2.82375 L13.2855,1.953 C13.74075,1.60125 14.37975,1.64175 14.77425,2.04825 L15.9555,3.2295 C16.35825,3.62025 16.39875,4.26 16.047,4.71375 L15.17625,5.835 C15.34425,6.16275 15.4875,6.50775 15.603,6.8655 L17.013,7.04475 C17.57475,7.113 18,7.59225 18,8.16 L18,9.84 C18,10.40775 17.57475,10.887 17.01,10.9545 L15.603,11.13375 C15.48675,11.4915 15.3435,11.8365 15.17625,12.16425 L16.047,13.28475 C16.3995,13.73925 16.35825,14.379 15.95175,14.7735 L14.7705,15.95475 C14.37975,16.3575 13.73925,16.39875 13.28625,16.04625 L12.165,15.1755 C11.83725,15.3435 11.49225,15.48675 11.1345,15.60225 L10.95525,17.01225 C10.887,17.57475 10.40775,18 9.84,18 L9.84,18 Z M5.7975,14.355 C5.85975,14.355 5.9235,14.37075 5.9805,14.40225 C6.39375,14.63325 6.8415,14.81925 7.311,14.95425 C7.455,14.9955 7.56075,15.1185 7.5795,15.267 L7.7895,16.917 C7.812,17.10525 7.97475,17.25 8.16,17.25 L9.84,17.25 C10.02525,17.25 10.188,17.10525 10.20975,16.92075 L10.4205,15.26775 C10.43925,15.11925 10.545,14.99625 10.689,14.955 C11.1585,14.82 11.60625,14.634 12.0195,14.403 C12.15075,14.3295 12.31425,14.34225 12.432,14.4345 L13.7445,15.4545 C13.89525,15.5715 14.10675,15.56175 14.23575,15.429 L15.4245,14.24025 C15.56025,14.10825 15.57075,13.89675 15.45375,13.74525 L14.43375,12.43275 C14.3415,12.31425 14.32875,12.1515 14.40225,12.02025 C14.63325,11.607 14.81925,11.15925 14.95425,10.68975 C14.9955,10.54575 15.1185,10.44 15.267,10.42125 L16.917,10.21125 C17.10525,10.188 17.25,10.02525 17.25,9.84 L17.25,8.16 C17.25,7.97475 17.10525,7.812 16.92075,7.79025 L15.26775,7.5795 C15.11925,7.56075 14.99625,7.455 14.955,7.311 C14.82,6.8415 14.634,6.39375 14.403,5.9805 C14.3295,5.84925 14.3415,5.6865 14.4345,5.568 L15.4545,4.2555 C15.57225,4.104 15.56175,3.8925 15.42975,3.765 L14.241,2.57625 C14.10975,2.43975 13.8975,2.42925 13.746,2.547 L12.4335,3.567 C12.31425,3.65925 12.1515,3.672 12.02025,3.5985 C11.6085,3.3675 11.16075,3.18225 10.68975,3.0465 C10.54575,3.00525 10.44,2.88225 10.42125,2.73375 L10.21125,1.08375 C10.188,0.89475 10.02525,0.75 9.84,0.75 L8.16,0.75 C7.97475,0.75 7.812,0.89475 7.79025,1.07925 L7.5795,2.73225 C7.56075,2.88075 7.455,3.00375 7.311,3.04575 C6.84,3.18075 6.39225,3.36675 5.9805,3.597 C5.84925,3.67125 5.6865,3.65775 5.56725,3.56625 L4.25475,2.54625 C4.10325,2.4285 3.8925,2.439 3.76425,2.571 L2.5755,3.7605 C2.43975,3.8925 2.42925,4.104 2.54625,4.2555 L3.56625,5.568 C3.6585,5.6865 3.67125,5.84925 3.59775,5.9805 C3.366,6.39375 3.18075,6.8415 3.04575,7.311 C3.0045,7.455 2.8815,7.56075 2.733,7.5795 L1.083,7.7895 C0.89475,7.812 0.75,7.97475 0.75,8.16 L0.75,9.84 C0.75,10.02525 0.89475,10.188 1.07925,10.20975 L2.73225,10.4205 C2.88075,10.43925 3.00375,10.545 3.045,10.689 C3.18,11.1585 3.366,11.60625 3.597,12.0195 C3.6705,12.15075 3.6585,12.3135 3.5655,12.432 L2.5455,13.7445 C2.42775,13.896 2.43825,14.1075 2.57025,14.235 L3.759,15.42375 C3.89025,15.5595 4.101,15.57 4.254,15.453 L5.5665,14.433 C5.63475,14.382 5.71575,14.355 5.7975,14.355 Z"
            id="Shape"
          />
          <path
            d="M9,13 C6.7944,13 5,11.2056 5,9 C5,6.7944 6.7944,5 9,5 C11.2056,5 13,6.7944 13,9 C13,11.2056 11.2056,13 9,13 Z M9,5.8 C7.2352,5.8 5.8,7.2352 5.8,9 C5.8,10.7648 7.2352,12.2 9,12.2 C10.7648,12.2 12.2,10.7648 12.2,9 C12.2,7.2352 10.7648,5.8 9,5.8 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ShareIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    className={className}
  >
    <title>share</title>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="2.1-Zoznamy_detail-search-autofill"
        transform="translate(-889.000000, -197.000000)"
        fill="#56AB2F"
        fill-rule="nonzero"
      >
        <g id="share" transform="translate(889.000000, 197.000000)">
          <path
            d="M15.9374542,18 L2.06240846,18 C0.924636859,18 0,17.0752202 0,15.937579 L0,5.06242102 C0,3.92464248 0.924636859,3 2.06240846,3 L4.68745424,3 C4.99795533,3 5.24995424,3.25200041 5.24995424,3.56250343 C5.24995424,3.87300642 4.99795533,4.12500687 4.68745424,4.12500687 L2.06240846,4.12500687 C1.54563904,4.12500687 1.12499999,4.54564848 1.12499999,5.06242102 L1.12499999,15.937579 C1.12499999,16.4542142 1.54563904,16.8749931 2.06240846,16.8749931 L15.9374542,16.8749931 C16.4542236,16.8749931 16.875,16.4542142 16.875,15.937579 L16.875,9.56244849 C16.875,9.25194551 17.1269989,8.99994506 17.4375,8.99994506 C17.7480011,8.99994506 18,9.25194551 18,9.56244849 L18,15.937579 C18,17.0752202 17.0752258,18 15.9374542,18 L15.9374542,18 Z"
            id="Path"
          />
          <path
            d="M4.58248034,12 C4.53975562,12 4.49688846,11.9954646 4.45416378,11.9848818 C4.19055226,11.925646 4,11.707944 4,11.4468115 L4,10.3209182 C4,6.28573438 7.40202688,3.00261204 11.5833526,3.00261204 L11.7777501,3.00261204 L11.7777501,0.563085002 C11.7777501,0.333425857 11.9224445,0.126993786 12.1433312,0.0406826324 C12.3633636,-0.0448039095 12.6161515,0.0068728319 12.7810689,0.172760678 L17.8366848,5.23928035 C18.0544384,5.45698236 18.0544384,5.80222698 17.8366848,6.01992899 L12.7810689,11.0864487 C12.6161515,11.2523365 12.361797,11.3034635 12.1433312,11.2185267 C11.9224445,11.1322156 11.7777501,10.9257835 11.7777501,10.6961243 L11.7777501,8.25673476 L10.8537569,8.25673476 C8.40691224,8.25673476 6.20801342,9.56871928 5.11454549,11.6801814 C5.01414238,11.8753436 4.8033671,12 4.58248034,12 L4.58248034,12 Z M11.5833526,4.1285053 C8.31662069,4.1285053 5.61157636,6.49656447 5.21566064,9.54769122 C6.62956398,8.02556379 8.65727911,7.1308415 10.8537569,7.1308415 L12.3610849,7.1308415 C12.6830869,7.1308415 12.9444197,7.3830405 12.9444197,7.69378813 L12.9444197,9.30002771 L16.606925,5.62960467 L12.9444197,1.95918167 L12.9444197,3.56555867 C12.9444197,3.8763063 12.6830869,4.1285053 12.3610849,4.1285053 L11.5833526,4.1285053 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const MenuIcon = ({ height = 32, width = 32, fill = "black" }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>menu 8</title>
      <g fill="#050505" stroke="#050505" strokeLinecap="round" strokeWidth="2">
        <line fill="none" x1="2" x2="30" y1="16" y2="16" />
        <line fill="none" stroke="#050505" x1="2" x2="30" y1="7" y2="7" />
        <line fill="none" stroke="#050505" x1="2" x2="30" y1="25" y2="25" />
      </g>
    </svg>
  );
};

export const FacebookIcon = ({ height = 32, width = 32, fill = "black" }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>logo facebook 2</title>
      <g>
        <path d="M30.7 0H1.3C.6 0 0 .6 0 1.3v29.3c0 .8.6 1.4 1.3 1.4H17V20h-4v-5h4v-4c0-4.1 2.6-6.2 6.3-6.2 1.8 0 3.3.2 3.7.2v4.3h-2.6c-2 0-2.5 1-2.5 2.4V15h5l-1 5h-4l.1 12h8.6c.7 0 1.3-.6 1.3-1.3V1.3C32 .6 31.4 0 30.7 0z" />
      </g>
    </svg>
  );
};

export const InstagramIcon = ({ height = 32, width = 32, fill = "black" }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>logo instagram 4</title>
      <g>
        <path d="M16 2.883c4.272 0 4.778.016 6.465.094 1.822.083 3.511.447 4.811 1.747 1.3 1.3 1.665 2.99 1.748 4.811.077 1.687.093 2.193.093 6.466s-.016 4.777-.093 6.465c-.083 1.821-.448 3.51-1.748 4.81-1.3 1.3-2.99 1.665-4.81 1.749-1.688.077-2.194.093-6.466.093s-4.778-.016-6.466-.093c-1.82-.083-3.51-.448-4.81-1.748-1.3-1.3-1.665-2.99-1.748-4.811-.077-1.688-.093-2.194-.093-6.466s.017-4.778.094-6.465c.083-1.822.447-3.511 1.748-4.811 1.3-1.3 2.989-1.665 4.81-1.748 1.687-.077 2.193-.093 6.465-.093M16 0c-4.345 0-4.89.018-6.597.096-2.6.119-4.884.756-6.718 2.59C.852 4.518.215 6.802.096 9.402.02 11.11 0 11.654 0 16c0 4.345.018 4.89.097 6.597.118 2.6.755 4.884 2.589 6.718 1.833 1.833 4.117 2.47 6.717 2.589C11.11 31.982 11.655 32 16 32s4.89-.018 6.597-.097c2.6-.118 4.884-.755 6.718-2.588 1.833-1.833 2.47-4.117 2.589-6.718C31.982 20.89 32 20.345 32 16s-.018-4.89-.096-6.597c-.119-2.6-.756-4.884-2.59-6.718C27.482.852 25.198.215 22.596.096 20.89.018 20.346 0 16 0zm0 7.784a8.216 8.216 0 1 0 0 16.432 8.216 8.216 0 0 0 0-16.432zm0 13.55a5.334 5.334 0 1 1 0-10.668 5.334 5.334 0 0 1 0 10.668zm6.621-13.875a1.92 1.92 0 0 0 3.84 0 1.92 1.92 0 0 0-3.84 0" />
      </g>
    </svg>
  );
};

export const YoutubeIcon = ({ height = 32, width = 32, fill = "black" }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>logo youtube 2</title>
      <g>
        <path d="M31.667 9.6s-.334-2.2-1.267-3.2c-1.2-1.267-2.6-1.267-3.2-1.333-4.467-.334-11.2-.334-11.2-.334s-6.733 0-11.2.334c-.6.066-2 .066-3.2 1.333C.667 7.4.333 9.6.333 9.6S0 12.2 0 14.8v2.4c0 2.6.333 5.2.333 5.2s.334 2.2 1.267 3.2c1.2 1.267 2.8 1.267 3.533 1.4 2.534.267 10.867.333 10.867.333s6.733 0 11.2-.333c.6-.067 2-.067 3.2-1.333.933-1 1.267-3.2 1.267-3.2s.333-2.6.333-5.2v-2.4c0-2.667-.333-5.267-.333-5.267zm-19 10.533v-9l8.666 4.534-8.666 4.466z" />
      </g>
    </svg>
  );
};
